<template>
  <button
    type="button"
    class="btn btn-success"
    :disabled="isSubmitting"
    @click="handleClick"
  >
    <i class="fa fa-fw fa-play"></i>
    Начать
  </button>
</template>

<script>
import { workShiftService } from "@/_shared/api-services";
import { useNotification } from "@/_shared/mixins";
export default {
  mixins: [useNotification],
  emits: ['on-start'],
  data() {
    return {
      isSubmitting: false,
    };
  },
  methods: {
    async handleClick() {
      this.isSubmitting = true;
      await workShiftService.start()
        .then((startDate) => this.$emit('on-start', startDate))
        .catch(({ message }) => this.showErrorNotification(message))
        .finally(() => this.isSubmitting = false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/_shared/features/work-shift-menu/StartButton.vue